import {Suspense} from 'react';
import { BrowserRouter } from "react-router-dom";
import {  ThemeProvider } from 'styled-components'
import Routes from "./routes";
import Loader from "./components/Loader"
import theme from "./theme/theme"
import GlobalStyle from './theme/globalStyle'
import Layout from './components/Layout'

function App() {
  return (
    <BrowserRouter>
      <GlobalStyle/>
      <ThemeProvider theme={theme}>
        <Layout>
          <Suspense fallback={<Loader/>}>
            <Routes/>
          </Suspense>
        </Layout>
      </ThemeProvider>
    </BrowserRouter>
  );
}

export default App;
